import { CalendarDate } from '@internationalized/date';
import {
  DriverStatus,
  enumAddressType,
} from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

export const useCreateDriverMutation = createMutationHook(
  'transportation.driverCreate',
  (params: {
    status: DriverStatus;
    firstName: string;
    lastName: string;
    licenseNumber?: string;
    licenseExpiration?: CalendarDate;
    phoneNumber: string;
    email: string;
    address: {
      streetAddress: string;
      city: string;
      state: string;
      postalCode: string;
      country: string;
      addressType: (typeof enumAddressType)[keyof typeof enumAddressType];
      isMailingAddress: boolean;
    };
  }) => ({
    transportationDriverCreate: {
      __args: {
        input: {
          status: params.status,
          firstName: params.firstName,
          lastName: params.lastName,
          licenseNumber: params.licenseNumber,
          licenseExpiration: params.licenseExpiration?.toString(),
          phoneNumber: params.phoneNumber,
          email: params.email,
          address: params.address,
        },
      },
      id: true,
      status: true,
      firstName: true,
      lastName: true,
      licenseNumber: true,
      licenseExpiration: true,
      phoneNumber: true,
      email: true,
      address: {
        streetAddress: true,
        city: true,
        state: true,
        postalCode: true,
        country: true,
        addressType: true,
        isMailingAddress: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
